/*eslint-disable*/
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  Box,
  Dialog,
  Button,
  Typography,
  makeStyles,
  Container,
} from '@material-ui/core';

const NotificationForgotPassword = ({
  email,
  onClose,
  parentClose,
  open,
  ...rest
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [editor, setEditor] = useState<boolean>(true);
  const [view, setView] = useState<boolean>(false);
  const { t } = useTranslation('account');
  const isUser = email.includes('@');

  const handleAllClose = () => {
    onClose();
    parentClose();
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth {...rest}>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          p: 3,
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '24px',
                  color: '#001930',
                  fontWeight: 700,
                  lineHeight: '25px',
                }}
              >
                {`¡Listo!`}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '0.875',
                  color: '#42526E',
                  textAlign: 'center',
                }}
              >
                {isUser ? (
                  <Trans i18nKey="account.forgotPassword.notification">
                    Hemos enviado el link para el restablecimiento de contraseña
                    al mail <strong>{{ email }}</strong>, por favor, ingrese al
                    link para restablecer la contraseña.
                  </Trans>
                ) : (
                  <Trans i18nKey="account.forgotPassword.notificationProvider">
                    Hemos enviado el link para el restablecimiento de contraseña
                    al mail registrado con el ruc <strong>{{ email }}</strong>,
                    por favor, ingrese al link para restablecer la contraseña.
                  </Trans>
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '0.875',
                  color: '#42526E',
                  textAlign: 'center',
                }}
              >
                <Trans i18nKey="account.forgotPassword.sendAgain">
                  ¿No recibiste el correo electrónico ? Mira en tu carpeta de
                  correo no deseado o vuelve a enviarlo.{' '}
                  <strong>
                    <a onClick={onClose}>vuelve a enviarlo</a>
                  </strong>
                  .
                </Trans>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              mt: 4,
              justifyContent: 'center',
            }}
          >
            <Button
              sx={{
                width: '50%',
                backgroundColor: '#024787',
              }}
              size="large"
              variant="contained"
              onClick={handleAllClose}
            >
              Continuar
            </Button>
          </Box>
        </Container>
      </Box>
    </Dialog>
  );
};

export default NotificationForgotPassword;
